/** Item grid column order (matches PO line data: srno → item → qty → price → uom → spec → amounts) */
export const PO_ITEM_GRID_HEADERS = [
  'Sr no',
  'Item No',
  'Description',
  'Item Specs',
  'Qty',
  'Unit Price',
  'Amount',
  'Discount',
  'VAT %',
  'VAT Amount',
  'Inventory Qty',
  'Packing UOM',
];

/** PO detail: Quotation Req | Contact No | Buyer Name */
export const PO_DETAIL_QUOTE_GRID = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gridTemplateRows: 'auto',
  gap: '0.75rem 1rem',
  alignItems: 'start',
  marginBottom: '0.75rem',
};

/** Keeps attachment control from stretching when remarks is tall */
export const PO_DETAIL_FIELD_CELL = {
  alignSelf: 'start',
};

/**
 * Remarks spans cols 1–2 (label col 1, textarea cols 2–3 of inner grid).
 * Sibling attachment cell sits in parent grid col 3 (under Buyer Name).
 */
export const PO_DETAIL_REMARKS_SPAN = {
  gridColumn: '1 / 2',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 2fr',
  gap: '0.75rem 1rem',
  alignItems: 'start',
};

/** Remarks textarea — width of col 1 + col 2 input areas (per PO layout mockup) */
export const PO_REMARKS_NOTE_STYLE = {
  gridColumn: '2 / 4',
  width: '100%',
  maxWidth: '100%',
  height: '85px',
  minHeight: '80px',
  maxHeight: '130px',
  resize: 'vertical',
  boxSizing: 'border-box',
};

/** Column widths for PO item line grids */
export const PO_ITEM_COL = {
  itemNo: { width: '150px', minWidth: '150px', maxWidth: '150px' },
  description: { width: '350px', minWidth: '300px', maxWidth: '350px' },
  specification: { width: '200px', minWidth: '200px', minHeight: '44px', resize: 'vertical', overflow: 'auto', boxSizing: 'border-box' },
};

/** First entry from GET_INV_TAX — default VAT % for new grid lines */
export const getDefaultVatOption = (vatList) => (Array.isArray(vatList) && vatList.length > 0 ? vatList[0] : null);

/** Keep row/user VAT if it exists in the list; otherwise use first option (not blank/0 label) */
export const resolveRowVat = (vatList, vatDec) => {
  const list = Array.isArray(vatList) ? vatList : [];
  const fallback = getDefaultVatOption(list);
  if (!fallback) {
    return { tax: null, rate: 0, description: '' };
  }
  const hasValidDec = vatDec !== undefined && vatDec !== null && vatDec !== '' && vatDec !== 0;
  const matched = hasValidDec ? list.find((tax) => tax.description === vatDec) : null;
  const tax = matched || fallback;
  return {
    tax,
    rate: tax.rate ?? 0,
    description: tax.description ?? '',
  };
};

/** Item master VAT when present in list; else first dropdown option */
export const resolveVatForItem = (vatList, itemVatDescription) => {
  const list = Array.isArray(vatList) ? vatList : [];
  if (itemVatDescription) {
    const fromItem = list.find((tax) => tax.description === itemVatDescription);
    
    if (fromItem) return fromItem;
  }
  return getDefaultVatOption(list);
};

export const getVatSelectValue = (row, vatList) => {
  const { tax } = resolveRowVat(vatList, row?.vatDec);
  if (!tax) return null;
  return { value: tax, label: tax.description };
};

export const mapVatSelectOptions = (vatList) => (Array.isArray(vatList) ? vatList : []).map((tax) => ({ value: tax, label: tax.description }));

const parsePx = (value) => parseInt(String(value).replace('px', ''), 10);

export const poCompactSelectStyles = (widthKey) => {
  const w = parsePx(PO_ITEM_COL[widthKey].width);
  return {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: 32,
      width: w,
      minWidth: w,
      maxWidth: w,
    }),
    valueContainer: (base) => ({ ...base, padding: '0 4px' }),
    singleValue: (base) => ({ ...base, fontSize: '12px' }),
    input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: '12px' }),
    indicatorsContainer: (base) => ({ ...base, padding: '0 2px' }),
  };
};
